import React from 'react';
import { filterSpeakersWithProgramSessions } from '../../../../data/filters/speakers/filterSpeakersWithProgramSessions';
import { useEventSpeakers } from '../../../../data/hooks/speakers/useEventSpeakers';
import SpeakersIcon from '../../../../resources/icons/speaker.png';
import ToolbarButton from '../ToolbarButton';
import { useEventSettings } from '../../../../data/hooks/events/useEventSettings';

function SpeakersToolbarButton(props) {
    const { eventId, href = './speakers', ...otherProps } = props,
        { show_speakers_list } = useEventSettings(eventId),
        speakers = useEventSpeakers(eventId, { filter: filterSpeakersWithProgramSessions });

    if (!show_speakers_list) return null;
    if (!speakers.length) return null;

    return <ToolbarButton href={href} src={SpeakersIcon} {...otherProps} />;
}

export default SpeakersToolbarButton;
